<template>
  <div v-show="items.length > 0" class="animated fadeIn">
    <b-card id="demoList">
      <div slot="header">
        <b-button :to="{name: 'welcome-list', params: {initCategoryCode: this.$route.params.categoryCode, initServiceCode: this.$route.params.serviceCode}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        样例信息
      </div>
      <b-row v-for="(item, index) in items" :key="index" :id="'pr' + item.code + index.toString()">
        <b-col sm="2" />
        <b-col>
          <hr class="hr-fade-content" :data-content="item.name">
          <v-md-preview v-if="item.ismd" :text="item.desc" />
          <div v-else v-html="item.desc" style="padding: 20px 12px !important;" />
        </b-col>
        <b-col sm="2" />
      </b-row>
    </b-card>
    <b-navbar class="flex-column demo-nav">
      <b-navbar-brand href="#">目录</b-navbar-brand>
      <b-nav pills vertical>
        <template v-for="(item, index) in items">
          <b-nav-item :key="index">
            <b-button variant="link" v-scroll-to="'#pr' + item.code + index.toString()" class="nav-btn">{{ item.name }}</b-button>
          </b-nav-item>
        </template>
      </b-nav>
    </b-navbar>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'

export default {
  name: 'welcome-demo-display',
  mixins: [Error],
  data () {
    return {
      items: [],
      currentPage: 1,
      perPage: 100000,
      scrollConf: {
        element: 'body',
        offset: 50,
        method: 'auto',
        throttle: 500
      }
    }
  },
  created () {
    this.getDemos()
  },
  methods: {
    getDemos () {
      api.fetchListData(this, api.getWelcomeDemoList(this.$route.params.serviceCode), 'app_demos', null, this.getDataCallback)
    },
    getDataCallback (resData) {
      this.items = resData['app_demos']
      if (!this.items.length) {
        this.$message.error('该服务暂无demo')
        this.$router.push({name: 'welcome-list', params: {initCategoryCode: this.$route.params.categoryCode, initServiceCode: this.$route.params.serviceCode}})
      }
    },
    anchor (anchorName) {
      let anchorElement = document.getElementById(anchorName)
      console.log(anchorElement.offsetTop)
      // if (anchorElement) {
      //   this.scrollTo({top: anchorElement.offsetTop, behavior: 'smooth'})
      // }
    }
  }
}
</script>

<style>
  .hr-fade-content {
    color: #000;
    border: 0;
    font-size: 30px;
    padding: 1em 0;
    position: relative;
    mask-image: linear-gradient(to right, transparent, black, transparent);
    -webkit-mask-image: linear-gradient(to right, transparent, black, transparent);
  }
  .hr-fade-content::before {
    content: attr(data-content);
    position: absolute;
    padding: 0 1ch;
    line-height: 3px;
    border: solid #5a5a5a;
    border-width: 0 99vw;
    width: fit-content;
    /* for 不支持fit-content浏览器 */
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
  }
  .demo-nav {
    position: fixed !important;
    z-index: 1;
    top: 150px;
    right: 50px;
    border-left: 1px solid #dbdbdb;
  }
  .nav-btn {
    text-decoration: underline !important;
  }
  .nav-btn:focus {
    outline: none !important;
    box-shadow:none !important;
  }
</style>



// WEBPACK FOOTER //
// DemoDisplay.vue?2b924f62